import React from 'react';
import { JSONTree } from 'react-json-tree';

import { Button } from '../components/Button.js';
import { jsonTreeTheme } from '../theme.js';

type Props = {
  ricosProps: any;
};

export const RicosPropsTab: React.FC<Props> = ({ ricosProps }) => {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          onClick={() => {
            // oxlint-disable-next-line no-console
            console.log(ricosProps);
          }}
        >
          Log Props
        </Button>
      </div>
      <JSONTree data={ricosProps} invertTheme={false} theme={jsonTreeTheme} hideRoot />
    </div>
  );
};
